"use strict";

var LoggerInstance = require("js-logger").get("WizardStore");

var EventEmitter = require("events").EventEmitter;

var Dispatcher = require("../Dispatcher");
var Constants = require("../Constants");

// State variables
var state = {
	wizards: []
};

var WizardStore = Object.assign({}, EventEmitter.prototype, {
	getState: function () {
		return state;
	},

	get: function (key) {
		return state[key];
	},

	getRawValue: function (name) {
		var wizard = state.wizards.find(w => w.name === name && w.status === "Complete");

		return wizard ? wizard.responseModel : null;
	},

	getValue: function (name, allowIncomplete) {
		var allowedStatuses = ["Complete"];
		if (allowIncomplete) {
			allowedStatuses.push("Incomplete");
		}

		var wizard = state.wizards.find(w => w.name === name && allowedStatuses.includes(w.status));

		return wizard ? JSON.parse(wizard.responseModel) : null;
	},

	addChangeListener: function (callback) {
		this.on(Constants.CHANGE_EVENT, callback);
	},

	removeChangeListener: function (callback) {
		this.removeListener(Constants.CHANGE_EVENT, callback);
	},

	emitChange: function () {
		this.emit(Constants.CHANGE_EVENT);
	}
});

WizardStore.dispatchToken = Dispatcher.register(function (action) {
	switch (action.actionType) {
		case Constants.WIZARD_RECEIVE_STORE_DATA:
			state.wizards = action.wizards;
			break;

		default:
			return true;
	};

	WizardStore.emitChange();
	return true;
});

module.exports = WizardStore;



// WEBPACK FOOTER //
// ./Javascript/designer/wizard/WizardStore.jsx